"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdentification = getIdentification;
exports.hasError = hasError;
exports.isError = isError;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function hasError(response) {
  return _typeof(response.data) != "object" || !!response.data._ERROR_MESSAGE_ || !!response.data._ERROR_MESSAGE_LIST_ || !!response.data.error;
}

function isError(response) {
  return response.code === 'error';
}

function getIdentification(identifications, id) {
  var externalId = '';

  if (identifications) {
    var externalIdentification = identifications.find(function (identification) {
      return identification.startsWith(id);
    });
    var externalIdentificationSplit = externalIdentification ? externalIdentification.split('/') : [];
    externalId = externalIdentificationSplit[1] ? externalIdentificationSplit[1] : '';
  }

  return externalId;
}